export default "__VITE_ASSET__cd81b02b__"